import { randomUUID } from '@/utils/uuid-util'
import { action, observable } from 'mobx'
import { required, validationContext } from 'validx'

/**
 * A custom service item in a scope change request.
 */
export class ScopeChangeCustomItemViewModel {
  /**
   * Identifies the item while its name is still being typed.
   */
  readonly key = randomUUID()

  /**
   * The service name.
   */
  @observable accessor name = ''

  /**
   * The requested quantity.
   */
  @observable accessor quantity = 1

  /**
   * Validation context for custom scope change.
   */
  readonly validation = validationContext(this, {
    name: [required('Service name is required.')],
    quantity: [
      (opts) =>
        opts.value >= 1 || opts.value <= -1 || 'Quantity cannot be zero.',
    ],
  })

  /**
   * Sets the quantity, which is at least 1.
   */
  @action.bound
  setQuantity(value: number | null) {
    this.quantity = Math.max(value ?? 1, 1)
  }

  /**
   * Sets the service name.
   */
  @action.bound
  setName(value: string) {
    this.name = value
  }
}
